import {
  Box,
  FormControlLabel,
  FormHelperText,
  Paper,
  Switch,
} from '@mui/material'
import { tsAnimal } from '../../../../Typescript/DB_Interface'
import AnimalButton from '../Buttons/AnimalButton'
import ValidatedTextfield from '../../../../Components/ValidatedTextfield'
import { tsAddAnimal } from '../ValidSamplesState'

function AnimalCard({
  animal,
  setAnimals,
  animals,
  index,
  onSampleEnterTab,
}: {
  animal: Partial<tsAnimal>
  setAnimals: any
  animals: tsAddAnimal
  index: number
  onSampleEnterTab?: any
}) {
  const uai = animal.UAI!
  return (
    <Paper
      elevation={3}
      key={animal.UAI}
      sx={{ width: 1, p: 2, display: 'flex' }}
    >
      <AnimalButton animal={animal} />
      <Box
        sx={{
          display: 'flex',
          width: 1 / 3,
          justifyContent: 'flex-end',
          flexDirection: 'column',
          ml: 2,
        }}
      >
        <FormControlLabel
          sx={{
            display: 'inline-block',
            justifyContent: 'flex-start',
            textAlign: 'left',
            flex: 1,
          }}
          control={
            <Switch
              checked={!!animals[uai] && !!animals[uai]?.length}
              onChange={(e) => {
                setAnimals((a: any) => {
                  return {
                    ...a,
                    [uai]: e.target.checked ? [{ sampleID: '' }] : [],
                  }
                })
              }}
              name={String(animal.UAI)}
              color="primary"
              inputProps={{ tabIndex: -1 }}
            />
          }
          labelPlacement="start"
          label="Collect"
        />
        <Box
          sx={{
            display: animals[uai] && !!animals[uai]?.length ? 'block' : 'none',
          }}
        >
          <ValidatedTextfield
            onKeyDown={(e: any) => {
              if (onSampleEnterTab) {
                onSampleEnterTab(e, index)
              }
            }}
            autoFocus={index === 0}
            required
            value={animals[uai][0]?.sampleID || ''}
            label="Sample ID"
            name={String(uai)}
            onChange={(e: any) => {
              const val = e.target.value
              if (!val) {
                setAnimals((a: any) => {
                  return {
                    ...a,
                    [uai]: [],
                  }
                })
              } else {
                setAnimals((a: any) => {
                  return {
                    ...a,
                    [uai]: [{ sampleID: val }],
                  }
                })
              }
            }}
            inputProps={{ valid: String(animals[uai][0]?.valid) }}
          />
          <FormHelperText error>
            {animals[animal.UAI!][0]?.message}
          </FormHelperText>
        </Box>
      </Box>
    </Paper>
  )
}

export default AnimalCard
